import { render, staticRenderFns } from "./bdiscitem.vue?vue&type=template&id=195b91d2&scoped=true&"
import script from "./bdiscitem.vue?vue&type=script&lang=js&"
export * from "./bdiscitem.vue?vue&type=script&lang=js&"
import style0 from "./bdiscitem.vue?vue&type=style&index=0&id=195b91d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b91d2",
  null
  
)

export default component.exports